module.exports = __webpack_public_path__ + "img/9788992288170.15cc445f.jpg";